import React from 'react';
import Helmet from 'react-helmet';
import CookieConsent from "react-cookie-consent";

import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import Link from './link';

const onDecline = () => {
    window.location.href = 'https://www.google.pl';
}

const Layout = ({children, transparentHeader, title}) => {
    return (
        <main className="main">
            <Helmet>
                <title>{title ? `${title} | KONTO - Biuro usług finansowo-księgowych` : `KONTO - Biuro usług finansowo-księgowych`}</title>
                <script src="https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit" async defer></script>
            </Helmet>
            <Header transparent={transparentHeader}/>
            {children}
            <Footer />
            <CookieConsent buttonText="Akceptuję" declineButtonText="Nie akceptuję" style={{backgroundColor: "rgb(0 0 0 / 80%)", fontSize: "16px"}} buttonStyle={{color: "#fff", backgroundColor: "green", padding: "12px 10px"}} declineButtonStyle={{padding: "12px 10px"}} onDecline={onDecline} enableDeclineButton flipButtons>Korzystając z tej strony akceptujesz, że w Twoim urządzeniu końcowym zostaną zainstalowane pliki cookies, które umożliwiają nam świadczenie usług. Brak zgody na pliki cookies oznacza, że pewne funkcjonalności strony mogą być niedostępne. Więcej informacji znajdziesz w <Link to="/polityka-prywatnosci">Polityce Prywatności</Link>.</CookieConsent>
        </main>
    )
}

export default Layout;